var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.token
    ? _c("div", { staticClass: "has-max-width" }, [
        _c("div", { staticClass: "level is-marginless mb-3" }, [
          _c(
            "div",
            { staticClass: "level-left" },
            [_c("token-name", { attrs: { token: _vm.token } })],
            1
          ),
          _c("div", { staticClass: "level-right" }, [
            _c("p", [_vm._v("Created " + _vm._s(_vm.created_date))]),
          ]),
        ]),
        _c("div", { staticClass: "token-panel" }, [
          _c("div", { staticClass: "columns is-variable is-1" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                { staticClass: "token-holder", class: { copied: _vm.copied } },
                [
                  _c("span", { staticClass: "token" }, [
                    _vm._v(_vm._s(_vm.key)),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "column is-narrow" }, [
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button is-light",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.copyToClipboard.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "icon is-small" },
                        [
                          _c("dc-icon", {
                            attrs: {
                              icon: "copy",
                              library: "far",
                              "no-margin": "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("strong", [_vm._v("Copy to clipboard")]),
                    ]
                  ),
                  _c(
                    "app-delete-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.revoke(_vm.token)
                        },
                      },
                    },
                    [
                      _c("strong", { staticClass: "has-text-danger" }, [
                        _vm._v("Delete API key"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }